export const HAS_UPPER = /[A-Z]/;
export const HAS_SPECIAL = /[^A-Za-z0-9]/;

export function getPasswordRequirementState(password) {
  const pw = password || '';
  return {
    lenOk: pw.length >= 8,
    capOk: HAS_UPPER.test(pw),
    specOk: HAS_SPECIAL.test(pw),
  };
}

/** Returns an error message, or undefined when valid. */
export function validateNewPassword(password) {
  if (!password) {
    return 'Required';
  }
  if (password.length < 8) {
    return 'At least 8 characters';
  }
  if (!HAS_UPPER.test(password)) {
    return 'Include one capital letter';
  }
  if (!HAS_SPECIAL.test(password)) {
    return 'Include one special character';
  }
  return undefined;
}
